module.exports = __webpack_public_path__ + "static/media/habbit-tracker1.80348847.jpg";